// using axios as current Http library
import axios from 'axios';
import axiosCancel from 'axios-cancel';

// add `cancel` prototype method to abort `XHR` requests and promise
axiosCancel( axios );

/**
 * @type {object}
 * @desc Http utility module provides easy abstractions over simple HTTP verbs.
 * Use Http.Get, Http.Post etc. methods to make AJAX network requests.
 * Currently, this module uses `axios` library to make HTTP calls, hence [config](https://github.com/axios/axios) object configuration structure is used.
 * @example
 * import Http from 'core/modules/http';
 * const promise = Http.get( config );
 * promise.then( response => {} ).catch( error => {} );
 */
export const Http = {};

/*************************************************************/

// HTTP execute method
// use this execute method to execute the axios request
Http.execute = ( config ) => {
    return axios( config );
};

// HTTP get method
// use this get method to execute the get request
Http.get = ( url ) => {
    return axios.get( url );
};

// HTTP post method
// use this get method to execute the post request
Http.post = ( url, data ) => {
    return axios.post( url, data );
};

// HTTP put method
// use this get method to execute the post request
Http.put = ( url, data ) => {
    return axios.put( url, data );
};

// HTTP delete method
// use this get method to execute the delete request
Http.delete = ( url ) => {
    return axios.delete( url );
};

// HTTP Cancel method
// use Http.cancel method to cancel request with the id
Http.cancel = ( id ) => {
    return axios.cancel( id );
};

// HTTP CancelAll method
// Use Http.cancelAll to cancel all the ongoing requests
Http.cancelAll = () => {
    return axios.cancelAll();
};
